/* FullMetal: tag WhatsApp chats with where the visitor came from.
   Visitors who arrive from a paid ad (utm_medium=paid/cpc/paid_social) are remembered for 7 days.
   When they tap any WhatsApp link, the pre-filled message gets "(ref: web-ad)"; everyone else gets "(ref: web)".
   The WhatsApp assistant (fullmetal-bot) reads the tag, records the lead source and hides the tag.
   Also reports a "Contact" event to the Meta Pixel when it is on the page. */
(function () {
  var KEY = 'fm_lead_src', DAYS = 7, PAID = /^(paid|cpc|ppc|paid_?social|paidsocial)$/i;
  var DEFAULT_TEXT = "Hi FullMetal, I'd like to ask about grillz.";
  function now() { return new Date().getTime(); }
  function remember() {
    try {
      var p = new URLSearchParams(window.location.search);
      if (PAID.test(p.get('utm_medium') || '')) {
        window.localStorage.setItem(KEY, JSON.stringify({ ref: 'web-ad', at: now() }));
      }
    } catch (e) {}
  }
  function currentRef() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (v && v.ref && now() - v.at < DAYS * 864e5) return v.ref;
    } catch (e) {}
    return 'web';
  }
  function isWhatsApp(url) {
    return url.hostname === 'wa.me' || /(^|\.)api\.whatsapp\.com$/.test(url.hostname) || (url.hostname === 'web.whatsapp.com' && url.pathname.indexOf('/send') === 0);
  }
  function tag(a) {
    var url;
    try { url = new URL(a.getAttribute('href'), window.location.href); } catch (e) { return; }
    if (!isWhatsApp(url)) return;
    var text = (url.searchParams.get('text') || '').replace(/\s*\(ref:[^)]*\)\s*$/i, '').trim() || DEFAULT_TEXT;
    url.searchParams.delete('text');
    var rest = url.searchParams.toString();
    // encodeURIComponent (%20), not URLSearchParams (+), so WhatsApp shows clean spaces
    a.setAttribute('href', url.origin + url.pathname + '?' + (rest ? rest + '&' : '') + 'text=' + encodeURIComponent(text + ' (ref: ' + currentRef() + ')'));
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Contact', { content_name: 'WhatsApp' }); } catch (e) {}
  }
  remember();
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a) tag(a);
  }, true);
})();
